export enum NotificationStatus {
  Default = 'default',
  Enabled = 'granted',
  Disabled = 'denied',
}
